var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@marketing/components/funnel/Buttons/Button';
import Flyout from '@marketing/components/funnel/Flyout';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import PetHealthConcernsInput from '@marketing/profile/common/PetHealthConcernsInput';
import { ProfileFormLayout, ProfileFormMain } from '@marketing/profile/common/ProfileFormLayout';
import { useState } from 'react';
import { useNavigate } from 'react-router';
var PetHealthConcernsForm = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), currentPet = _a.currentPet, currentPetIndex = _a.currentPetIndex, serverLoading = _a.serverLoading, profileBasePath = _a.profileBasePath, sendFunnelGTMEvent = _a.sendFunnelGTMEvent;
    var _b = useState(''), hasHealthConcerns = _b[0], setHasHealthConcerns = _b[1];
    var _c = useState(false), showModal = _c[0], setShowModal = _c[1];
    var handleOptionChange = function (e) {
        setHasHealthConcerns(e.target.value);
    };
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/purchasing_motivations"), {
            viewTransition: true,
        });
    };
    var proceed = function () {
        setShowModal(false);
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/calculating"), { viewTransition: true });
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        sendFunnelGTMEvent('click-next_health_question');
        if (hasHealthConcerns === 'yes') {
            setShowModal(true);
        }
        else {
            proceed();
        }
    };
    var onToggleModal = function () {
        setShowModal(false);
    };
    var formId = 'pet-health-concerns-form';
    return (_jsxs(ProfileFormLayout, __assign({ disableNext: !hasHealthConcerns, formId: formId, handleClickPrevious: handleClickPrevious }, { children: [_jsx(ProfileFormMain, __assign({ h1: "Nom Nom Sign Up: Your Dog\u2019s Health Concerns", widthClassName: "w-full md:max-w-md" }, { children: _jsx("form", __assign({ id: formId, onSubmit: handleSubmit }, { children: _jsx(PetHealthConcernsInput, { hasHealthConcerns: hasHealthConcerns, handleOptionChange: handleOptionChange, petName: currentPet.name }) })) })), _jsx(Flyout, __assign({ isOpen: showModal, onToggle: onToggleModal, isFullScreenOnMobile: false, isModalOnTablet: true }, { children: _jsxs("div", __assign({ className: "text-center grid grid-cols-1 gap-8 md:gap-10 px-5 py-12 md:p-10" }, { children: [_jsx("p", __assign({ className: "text-sm-head-m md:text-sm-head-d font-display" }, { children: "Important Notice" })), _jsx("p", { children: "Nom Nom diets are complete and balanced for all life stages, and are recommended for healthy dogs. If your dog has a medical condition that may require a prescription diet, please consult with your veterinarian before starting Nom Nom or any new dog food." }), _jsx("fieldset", __assign({ disabled: serverLoading }, { children: _jsxs("div", __assign({ className: "w-full md:w-[332px] mx-auto grid grid-cols-1 gap-6" }, { children: [_jsx(Button, __assign({ onClick: proceed, theme: "light" }, { children: "I\u2019d like to continue" })), _jsx("button", __assign({ className: "text-shoe underline font-medium text-sm-med-m md:text-sm-med-d hover:text-squash-700", onClick: function () { return setShowModal(false); } }, { children: "I\u2019ll come back later" }))] })) })), _jsx("p", __assign({ className: "text-sm-reg-m md:text-sm-reg-d" }, { children: "Note: We\u2019ll preserve your progress for up to 60 days, so you won\u2019t need to start again when you return." }))] })) }))] })));
};
export default PetHealthConcernsForm;
